"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectorArrow = exports.ArrowWrap = exports.labelOffsetStyle = exports.StyledInputWrap = exports.StyledInput = exports.StyledLabel = exports.Relative = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("../utils");
const components_1 = require("../utils/InputElement/components");
exports.Relative = app_1.styled.div `
  position: relative;
  flex: 1;
`;
exports.StyledLabel = (0, app_1.styled)(utils_1.Label) `
  user-select: none;
  position: absolute;
  top: 0.125rem;
  bottom: 0.125rem;
  left: ${(theme) => theme.spacing.small};
  display: flex;
  align-items: center;
  padding: 0.15rem;
  transition: 150ms all;
  font-size: 1.0625rem;
  color: ${(theme) => theme.colors.gray};
  margin: 0;
  background-color: white;
  cursor: pointer;
  ${(theme) => { var _a; return (_a = theme.inputs.select) === null || _a === void 0 ? void 0 : _a.label; }}
`;
exports.StyledInput = (0, app_1.styled)(components_1.Input) `
  pointer-events: none;
  background: transparent;
  cursor: pointer;
  flex: 1;
  ${app_1.styled.invalid `
    color: ${(theme) => theme.colors.error};
  `}
  ${(theme) => { var _a; return (_a = theme.inputs.select) === null || _a === void 0 ? void 0 : _a.css; }}
`;
exports.StyledInputWrap = app_1.styled.div `
  cursor: pointer;
  position: relative;
`;
exports.labelOffsetStyle = (0, app_1.css) `
  top: -0.625rem;
  bottom: unset;
  left: 0.5rem;
  font-size: 0.8125rem;
  padding: 0 0.25rem;
`;
exports.ArrowWrap = app_1.styled.div `
  position: absolute;
  right: ${(theme) => theme.spacing.small};
  top: 50%;
`;
function SelectorArrow() {
    return ((0, jsx_runtime_1.jsx)(exports.ArrowWrap, { children: (0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "10", height: "6", viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M0 0.5L5 5.5L10 0.5H0Z", fill: "#6E7080" }) })) }));
}
exports.SelectorArrow = SelectorArrow;
